import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { promotionActions } from "$STORE/promotionSlice";
import { Radio } from "antd";
import NotStarted from "./NotStarted";
import InProgress from "./InProgress";
import Claimable from "./Claimable";
import Completed from "./Completed";

const MyPromotionTabs = () => {
    const dispatch = useDispatch();
    const myPromotionSubtab = useSelector(
        (state) => state.promotion.myPromotionSubtab
    );

    const renderContent = () => {
        switch (myPromotionSubtab) {
            case "notStarted":
                return <NotStarted />;
            case "inProgress":
                return <InProgress />;
            case "claimable":
                return <Claimable />;
            case "completed":
                return <Completed />;
            default:
                return null;
        }
    };

    const gtagMapping = {
        notStarted: {
            action: "View Ready to Start Bonus",
            name: "Bonus_Category_C_ReadyToStart",
        },
        inProgress: {
            action: "View Ongoing Bonus",
            name: "Bonus_Category_C_Ongoing",
        },
        claimable: {
            action: "View Ready to Claim Bonus",
            name: "Bonus_Category_C_Ready",
        },
        completed: {
            action: "View Complete Bonus",
            name: "Bonus_Category_C_Complete",
        },
    };

    return (
        <>
            <div className="my-promotion-container">
                {/* Tab 切换按钮 */}
                <Radio.Group
                    buttonStyle="solid"
                    className="my-promotion-filter-box"
                    defaultValue="notStarted"
                    value={myPromotionSubtab}
                    onChange={(e) => {
                        const value = e.target.value;

                        // 根據選中的值調用 Pushgtagdata
                        if (gtagMapping[value]) {
                            const { action, name } = gtagMapping[value];
                            Pushgtagdata("Bonus", action, name);
                        }

                        // 更新 Redux 狀態
                        dispatch(promotionActions.setMyPromotionSubtab(value));
                    }}
                >
                    {/* 待开始 */}
                    <Radio.Button value="notStarted">กำลังจะเริ่ม</Radio.Button>
                    {/* 进行中 */}
                    <Radio.Button value="inProgress">กำลังดำเนินการ</Radio.Button>
                    {/* 可领取 */}
                    <Radio.Button value="claimable">กดรับโบนัส</Radio.Button>
                    {/* 已完成 */}
                    <Radio.Button value="completed">สิ้นสุด</Radio.Button>
                </Radio.Group>

                {/* 内容区域 */}
                {renderContent()}
            </div>
        </>
    );
};

export default MyPromotionTabs;
